/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AppConfigResponseDto } from '../models';
/**
 * RestAppConfigApi - axios parameter creator
 */
export const RestAppConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get application configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAppConfigApi - functional programming interface
 */
export const RestAppConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAppConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get application configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAppConfigApi.getAppConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAppConfigApi - factory interface
 */
export const RestAppConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAppConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Get application configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppConfig(options?: RawAxiosRequestConfig): AxiosPromise<AppConfigResponseDto> {
            return localVarFp.getAppConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAppConfigApi - interface
 */
export interface RestAppConfigApiInterface {
    /**
     * 
     * @summary Get application configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAppConfig(options?: RawAxiosRequestConfig): AxiosPromise<AppConfigResponseDto>;

}

/**
 * RestAppConfigApi - object-oriented interface
 */
export class RestAppConfigApi extends BaseAPI implements RestAppConfigApiInterface {
    /**
     * 
     * @summary Get application configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAppConfig(options?: RawAxiosRequestConfig) {
        return RestAppConfigApiFp(this.configuration).getAppConfig(options).then((request) => request(this.axios, this.basePath));
    }
}

